


const ContactsPage = () => {
    return ( 
        <div className="ContactsPage">
            <div className="container">
                
            </div>
        </div>
     );
}
 
export default ContactsPage;